<template>
  <div class="pdf-view">
    <div class="pdf-view-container">
      <div class="pdf-tools">
        <div class="pdf-tools-main">
          <div class="document-heading">
            <span class="document-kicker">PDF 对照阅读</span>
            <div class="title" :title="title">{{ title }}</div>
          </div>
          <div class="lange">
            <i class="el-icon-connection"></i>
            <span>{{ language }}</span>
          </div>
          <button
            type="button"
            class="download"
            data-track-text="下载文档"
            aria-label="下载文档"
            @click="downloadFile"
          >
            <i class="el-icon-download"></i>
            <span>下载文档</span>
          </button>
        </div>
        <div class="mobile-pane-switch" role="tablist" aria-label="阅读内容切换">
          <button
            type="button"
            role="tab"
            :aria-selected="mobilePane === 'origin'"
            :class="{ active: mobilePane === 'origin' }"
            data-track-text="移动端查看原文"
            @click="switchMobilePane('origin')"
          >原文</button>
          <button
            type="button"
            role="tab"
            :aria-selected="mobilePane === 'translate'"
            :class="{ active: mobilePane === 'translate' }"
            data-track-text="移动端查看译文"
            @click="switchMobilePane('translate')"
          >译文</button>
        </div>
      </div>
      <div class="pdf-container">
        <div
          class="pdf-origin"
          :class="[showTranslateFile ? '' : 'full']"
          ref="pdfContainer"
          v-show="showOriginFile && (!isMobile || mobilePane === 'origin')"
          @mouseup.stop="handleTextSelect"
          @touchend.stop="handleTextSelect"
        >
          <div class="pane-label"><i class="el-icon-document"></i> 原文</div>
          <el-scrollbar class="origin-scrollbar" ref="originScrollbar">
            <vue-pdf-embed
              ref="pdfOriginRef"
              :annotationLayer="false"
              :textLayer="true"
              :source="originalUrl"
              v-if="isRenderPdf"
            />

            <div
              v-for="(highlight, index) in highlightStyleList"
              :key="index"
              class="highlight-layer highlight"
              :style="getHighlightStyle(highlight)"
            ></div>

            <!-- 操作按钮 -->
            <div
              v-if="showActions"
              class="action-buttons"
              :style="buttonPosition"
            >
	              <button class="ai item" data-track-text="PDF划词AI翻译" aria-label="PDF划词AI翻译" @click="aitTranslate">
                <span class="icon el-icon-AIwenda"></span>
                <span class="text">AI翻译</span>
              </button>
	              <button class="high-light item" data-track-text="PDF划词高亮" aria-label="PDF划词高亮" @click="handleSelection">
                <span class="icon el-icon-wenbengaoliang"></span>
                <span class="text">高亮</span>
              </button>
	              <button class="note item" data-track-text="PDF划词添加笔记" aria-label="PDF划词添加笔记" @click="addNote">
                <span class="icon el-icon-biji"></span>
                <span class="text">笔记</span>
              </button>
            </div>
            <div v-if="isShowNote" class="note-pop" :style="buttonPosition">
              <div class="title">
                笔记
                <i class="el-icon-close close" data-track-text="关闭笔记" aria-label="关闭笔记" @click="isShowNote = false"></i>
              </div>
              <el-input
                rows="4"
                resize="none"
                class="note-message"
                type="textarea"
                placeholder="请输入笔记内容"
                v-model="noteMess"
                maxlength="100"
              >
              </el-input>
	              <button class="save-note" data-track-text="保存PDF笔记" aria-label="保存PDF笔记" @click="saveNote">保存</button>
            </div>
          </el-scrollbar>
        </div>
        <div class="action" aria-label="PDF 对照显示方式">
          <button type="button" class="show-origin" data-track-text="仅看译文" aria-label="仅看译文" @click="showTranslate">
            <span class="el-icon-zuo_filled"></span>
          </button>
          <button type="button" class="show-all" data-track-text="原文译文并排" aria-label="原文译文并排" @click="showAll">
            <span class="el-icon-zhongxinfenxi"></span>
          </button>
          <button type="button" class="show-translate" data-track-text="仅看原文" aria-label="仅看原文" @click="showOrigin">
            <span class="el-icon-zuo_filled"></span>
          </button>
        </div>
        <div
          class="pdf-translate"
          @mouseenter="isShowDownload = true"
          @mouseleave="isShowDownload = false"
          :class="[showOriginFile ? '' : 'full']"
          v-show="showTranslateFile && (!isMobile || mobilePane === 'translate')"
        >
          <div class="pane-label"><i class="el-icon-document-checked"></i> 译文</div>
          <!-- <span class="download-file" @click="downloadFile">
          <i class="el-icon-download"></i>
          下载
        </span> -->
          <el-scrollbar class="translate-scrollbar">
            <vue-pdf-embed
              ref="pdfTranslateRef"
              :annotationLayer="false"
              :textLayer="false"
              :source="translateUrl"
              v-if="isRenderPdf"
            />
          </el-scrollbar>
        </div>
      </div>
    </div>
    <div class="pdf-ai-container">
      <div class="blank" :class="[showAINote ? '' : 'full']"></div>
      <div class="pdf-ai" v-show="showAINote">
          <button
            type="button"
            class="pack-up"
            data-track-text="收起AI笔记"
            aria-label="收起AI笔记"
            @click="showAINote = false"
          ><i class="el-icon-close"></i></button>
        <el-tabs type="border-card" v-model="selectTab">
          <el-tab-pane label="笔记" name="note">
            <el-scrollbar class="note-scrollbar" v-if="selectTab === 'note'">
              <div class="note-list">
                <div
                  class="note-item"
                  v-for="(item, index) in noteList"
                  :key="item.originText"
                >
                  {{ item.originText }}
                  <span
                    class="el-icon-guanbi2 delete-note"
                    data-track-text="删除笔记"
                    aria-label="删除笔记"
                    @click="deleteNote(index)"
                  ></span>
                  <div class="note">{{ item.note }}</div>
                </div>
                <div v-if="noteList.length === 0" class="empty">暂无笔记</div>
              </div>
            </el-scrollbar>
          </el-tab-pane>
          <el-tab-pane label="AI翻译" name="aiTalk">
            <el-scrollbar
              class="ai-scrollbar answer-container"
              ref="answerScrollbarRef"
              v-if="selectTab === 'aiTalk'"
            >
              <div ref="chatListDom" class="ai-list">
                <div
                  v-for="(item, index) of messageList.filter(
                    (v) => v.role !== 'system'
                  )"
                  :key="index"
                  :class="[item.role === 'assistant' ? 'left' : 'right']"
                >
                  <div
                    :class="[
                      'answer-item',
                      'group',
                      item.role === 'assistant' ? 'assistant' : 'user',
                    ]"
                  >
                    <div v-if="item.role === 'user'" class="user-answer">
                      {{ item.content }}
                    </div>
                    <div v-else>
                      <div
                        class="prose"
                        v-if="item.content"
                        v-html="markdownRender.render(item.content)"
                      ></div>
                      <Loding v-else />
                    </div>
                  </div>
                </div>
              </div>
            </el-scrollbar>
            <div class="chat-editor" v-if="selectTab === 'aiTalk'">
              <el-select
                class="select-lang"
                v-model="currentLang"
                placeholder="请选择"
                size="mini"
              >
                <el-option
                  v-for="item in langList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input
                rows="4"
                resize="none"
                class="editor-message"
                type="textarea"
                placeholder="请输入要翻译的文字....."
                v-model="editorMess"
                maxlength="100"
                @keydown.enter="sendMessage"
              >
              </el-input>
              <div
                class="send-message"
                data-track-text="发送AI消息"
                aria-label="发送AI消息"
                :class="[isTalking || !editorMess ? '' : 'active']"
                @click="sendMessage"
              >
                <span class="send"></span>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!-- <div class="tabs">
          <div
            class="tab"
            :class="[selectTab === 'note' ? 'select' : '']"
            @click="selectTabChange('note')"
          >
            <span>笔记</span>
          </div>
          <div
            class="tab"
            :class="[selectTab === 'aiTalk' ? 'select' : '']"
            @click="selectTabChange('aiTalk')"
          >
            <span>AI问答</span>
          </div>
        </div> -->
      </div>
    </div>
    <el-dialog
      :title="downloadTitle"
      :visible.sync="centerDialogVisible"
      width="555px"
      center
    >
      <div :class="downloadClass">
        <div
          v-show="isDownload"
          class="download-section-title"
          style="
            text-align: left;
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #666666;
            margin-left: 70px;
          "
        >
          译文下载
        </div>
        <div v-show="isDownload" class="download-options" style="margin: 0 44.5px">
          <div class="down-type">
            <img
              src="../../../assets/doc.png"
              alt=""
              data-track-text="选择DOC格式"
              aria-label="选择DOC格式"
              style="width: 54px; height: 68px"
              @click="radio = 'doc'"
            />
            <el-radio v-model="radio" label="doc"></el-radio>
            <div style="line-height: 0; margin-top: 9px; text-align: center">
              doc
            </div>
          </div>
          <div class="down-type">
            <img
              src="../../../assets/docx.png"
              alt=""
              data-track-text="选择DOCX格式"
              aria-label="选择DOCX格式"
              style="width: 54px; height: 68px"
              @click="radio = 'docx'"
            />
            <el-radio v-model="radio" label="docx"></el-radio>
            <div style="text-align: center; line-height: 0; margin-top: 9px">
              docx
            </div>
          </div>
          <div class="down-type">
            <img
              src="../../../assets/pdf.png"
              alt=""
              data-track-text="选择PDF格式"
              aria-label="选择PDF格式"
              style="width: 54px; height: 68px"
              @click="radio = 'pdf'"
            />
            <el-radio v-model="radio" label="pdf"></el-radio>
            <div style="text-align: center; line-height: 0; margin-top: 9px">
              pdf
            </div>
          </div>
          <div class="down-type">
            <img
              src="../../../assets/txt.png"
              alt=""
              data-track-text="选择TXT格式"
              aria-label="选择TXT格式"
              style="width: 54px; height: 68px"
              @click="radio = 'txt'"
            />
            <el-radio v-model="radio" label="txt"></el-radio>
            <div style="text-align: center; line-height: 0; margin-top: 9px">
              txt
            </div>
          </div>
        </div>
        <div
          v-show="isDownload"
          class="download-section-title download-section-title--secondary"
          style="
            width: 115px;
            text-align: left;
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #666666;
            margin-left: 70px;
            margin-top: 120px;
          "
        >
          双语对照下载
        </div>
        <div v-show="isDownload" class="download-options download-options--bilingual" style="margin: 0px 44.5px">
          <div class="down-type">
            <img
              src="../../../assets/docx.png"
              alt=""
              data-track-text="选择原文批注DOCX"
              aria-label="选择原文批注DOCX"
              style="width: 54px; height: 68px"
              @click="radio = 'commentsone'"
            />
            <el-radio v-model="radio" label="commentsone"></el-radio>
            <div style="line-height: 0; margin-top: 9px">原文做批注</div>
          </div>
          <div class="down-type">
            <img
              src="../../../assets/docx.png"
              alt=""
              data-track-text="选择译文批注DOCX"
              aria-label="选择译文批注DOCX"
              style="width: 54px; height: 68px"
              @click="radio = 'commentstwo'"
            />
            <el-radio v-model="radio" label="commentstwo"></el-radio>
            <div style="line-height: 0; margin-top: 9px">译文做批注</div>
          </div>
        </div>
        <div
          v-show="isDownload"
          class="download-dialog-actions"
          style="
            position: absolute;
            left: 50%;
            top: 85%;
            transform: translate(-50%, 0px);
          "
        >
          <el-button
            class="el-button--primarys"
            type="primary"
            data-track-text="确认下载文档"
            aria-label="确认下载文档"
            style="margin-right: 11px"
            :loading="downloadDocLoad"
            @click="downloadDoc"
            >下 载
          </el-button>
          <el-button
            class="el-button--defaults"
            data-track-text="取消下载文档"
            aria-label="取消下载文档"
            @click="centerDialogVisible = false"
            >取 消</el-button
          >
        </div>
        <div v-show="!isDownload" class="download-progress-state">
          <div style="line-height: 0; text-align: center">
            <img
              src="../../../assets/downloadjindu.png"
              alt=""
              style="height: 166px; width: 330px"
            />
          </div>
          <div
            style="
              text-align: center;
              width: 360px;
              height: 48px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgb(52, 52, 52);
              line-height: 30px;
              margin-left: 50%;
              transform: translate(-50%, 0px);
              margin-bottom: 42px;
            "
          >
            <span>{{ downloadMessage }}</span>
          </div>
          <div
            style="position: absolute; left: 50%; transform: translate(-50%, 0)"
          >
            <el-progress
              :color="customColorDownload"
              style="width: 395px"
              id="test"
              :text-inside="true"
              :stroke-width="28"
              :percentage="downloadPercentage"
            ></el-progress>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="downloadTitle"
      :visible.sync="centerDialogVisiblePro"
      width="555px"
      center
    >
      <div :class="downloadClass" style="height: 270px">
        <div
          v-show="isDownload"
          class="download-section-title"
          style="
            text-align: left;
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #666666;
            margin-left: 70px;
          "
        >
          译文下载
        </div>
        <div v-show="isDownload" class="download-options" style="margin: 0 44.5px">
          <div class="down-type">
            <img
              src="../../../assets/doc.png"
              alt=""
              data-track-text="选择DOC格式"
              aria-label="选择DOC格式"
              style="width: 54px; height: 68px"
              @click="radio = 'doc'"
            />
            <el-radio v-model="radio" label="doc"></el-radio>
            <div style="line-height: 0; margin-top: 9px; text-align: center">
              doc
            </div>
          </div>
          <div class="down-type">
            <img
              src="../../../assets/docx.png"
              alt=""
              data-track-text="选择DOCX格式"
              aria-label="选择DOCX格式"
              style="width: 54px; height: 68px"
              @click="radio = 'docx'"
            />
            <el-radio v-model="radio" label="docx"></el-radio>
            <div style="text-align: center; line-height: 0; margin-top: 9px">
              docx
            </div>
          </div>
          <div class="down-type">
            <img
              src="../../../assets/pdf.png"
              alt=""
              data-track-text="选择PDF格式"
              aria-label="选择PDF格式"
              style="width: 54px; height: 68px"
              @click="radio = 'pdf'"
            />
            <el-radio v-model="radio" label="pdf"></el-radio>
            <div style="text-align: center; line-height: 0; margin-top: 9px">
              pdf
            </div>
          </div>
          <div class="down-type">
            <img
              src="../../../assets/txt.png"
              alt=""
              data-track-text="选择TXT格式"
              aria-label="选择TXT格式"
              style="width: 54px; height: 68px"
              @click="radio = 'txt'"
            />
            <el-radio v-model="radio" label="txt"></el-radio>
            <div style="text-align: center; line-height: 0; margin-top: 9px">
              txt
            </div>
          </div>
        </div>
        <div
          v-show="isDownload"
          class="download-dialog-actions"
          style="
            position: absolute;
            left: 50%;
            top: 85%;
            transform: translate(-50%, -15px);
          "
        >
          <el-button
            class="el-button--primarys"
            type="primary"
            data-track-text="确认下载专业文档"
            aria-label="确认下载专业文档"
            style="margin-right: 11px"
            :loading="downloadDocLoad"
            @click="downloadDoc"
            >下 载
          </el-button>
          <el-button
            class="el-button--defaults"
            data-track-text="取消下载专业文档"
            aria-label="取消下载专业文档"
            @click="centerDialogVisiblePro = false"
            >取 消</el-button
          >
        </div>
        <div v-show="!isDownload" class="download-progress-state">
          <div style="line-height: 0; text-align: center">
            <img
              src="../../../assets/downloadjindu.png"
              alt=""
              style="height: 166px; width: 330px"
            />
          </div>
          <div
            style="
              text-align: center;
              width: 360px;
              height: 48px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgb(52, 52, 52);
              line-height: 30px;
              margin-left: 50%;
              transform: translate(-50%, 0px);
              margin-bottom: 42px;
            "
          >
            <span>{{ downloadMessage }}</span>
          </div>
          <div
            style="position: absolute; left: 50%; transform: translate(-50%, 0)"
          >
            <el-progress
              :color="customColorDownload"
              style="width: 395px"
              id="test"
              :text-inside="true"
              :stroke-width="28"
              :percentage="downloadPercentage"
            ></el-progress>
          </div>
        </div>
      </div>
    </el-dialog>
    <DarggDrawer v-if="!showAINote" @handleClick="handleClick" />
    <PackagePop ref="packagePop" />
  </div>
</template>
<script>
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import screenfull from "screenfull";
import RegionScreenshot from "region-screenshot-js";
import { translateServiceClient } from "@/tools/api/service";
import { documentRequest, readingFileRequest } from "@/tools/api/translate-api";
import Loding from "../../modules/Loding.vue";
import MarkdownIt from "markdown-it/dist/markdown-it";
import DarggDrawer from "./DarggDrawer";
import languages from "../../../../language.json";
import PackagePop from "../../modules/PackagePop";
const markdownRender = new MarkdownIt({
  html: true, // 允许HTML标签  识别 a标签
});
export default {
  // 组件名称
  name: "PdfView",
  components: {
    VuePdfEmbed,
    Loding,
    DarggDrawer,
    PackagePop,
  },
  props: {
    isShowMenu: {
      type: Boolean,
      default: false,
    },
  },
  // 变量声明
  data() {
    return {
      selectTab: "note",
      noteList: [],
      originalUrl: "",
      translateUrl: "",
      isShowDownload: false,
      downloadTitle: "确定下载该文件的译文版本吗？",
      downloadClass: "downloadClass",
      downloadMessage: "下载大型文档或转换文档时，需等待时间较长请您耐心等待！",
      downloadPercentage: 0,
      isDownload: true,
      downloadDocLoad: false,
      radio: "pdf",
      centerDialogVisible: false,
      centerDialogVisiblePro: false,
      customColorDownload: "var(--primary-dark)",
      downloadTimer: "",
      title: "",
      highlights: [],
      highlightStyleList: [],
      showActions: false,
      currentSelection: null,
      buttonPosition: {},
      isShowNote: false,
      noteMess: "",
      selectText: "",
      chatNumber: "",
      messageList: [],
      markdownRender,
      editorMess: "",
      isTalking: false,
      conversationId: "",
      decoder: new TextDecoder("utf-8"),
      showOriginFile: true,
      showTranslateFile: true,
      showAINote: false,
      renderKey: 0,
      pdfScale: 1,
      assistantList: [],
      currentAssistant: {},
      language: "",
      isRenderPdf: true,
      isMobile: false,
      mobilePane: "origin",
      resizeTimer: null,
      renderTimer: null,
      langList: [
        {
          label: "中文回答",
          value: "zh",
        },
        {
          label: "英文回答",
          value: "en",
        },
      ],
      currentLang: "zh",
    };
  },
  watch: {
    messageList: {
      handler() {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      },
      deep: true, // 深度监听，以便能够检测到数组内部对象的变化
    },
    isShowMenu(val) {
      this.ReRenderPdf();
    },
    showAINote() {
      this.ReRenderPdf();
    },
  },
  // 实例初始化之后,进行数据侦听和事件/侦听器的配置之前同步调用
  beforeCreate() {},
  // 实例创建，挂载阶段未开始，可进行数据初始化
  created() {},
  mounted() {
    this.syncViewportMode(false);
    window.addEventListener("resize", this.handleResize);
    this.initPdf();
    this.getAssistant();
    this.$refs.originScrollbar.wrap.addEventListener(
      "scroll",
      this.handleScroll
    );
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.$refs.originScrollbar && this.$refs.originScrollbar.wrap) {
      this.$refs.originScrollbar.wrap.removeEventListener(
        "scroll",
        this.handleScroll
      );
    }
    clearTimeout(this.resizeTimer);
    clearTimeout(this.renderTimer);
    clearInterval(this.downloadTimer);
  },
  // 方法
  methods: {
    switchMobilePane(pane) {
      this.mobilePane = pane;
      this.showOriginFile = true;
      this.showTranslateFile = true;
      this.ReRenderPdf();
    },
    syncViewportMode(render = true) {
      const nextMobile = window.matchMedia("(max-width: 768px)").matches;
      if (nextMobile === this.isMobile) return;
      this.isMobile = nextMobile;
      if (nextMobile) {
        this.mobilePane =
          this.showTranslateFile && !this.showOriginFile
            ? "translate"
            : "origin";
        this.showOriginFile = true;
        this.showTranslateFile = true;
      }
      if (render) this.ReRenderPdf();
    },
    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.syncViewportMode(false);
        this.ReRenderPdf();
      }, 120);
    },
    getLanguageName(val) {
      return languages.find((item) => item.value === val).label;
    },
    getAssistant() {
      this.$http
        .get("/chatApi/app/api/assistant", {
          params: {
            typeId: 14,
          },
        })
        .then((res) => {
          this.assistantList = res.data.data;
          this.currentAssistant = this.assistantList[0];
        });
    },
    handleClick(type) {
      this.showAINote = true;
      this.selectTab = type;
    },
    handleScroll() {
      const scrollTop = this.$refs.originScrollbar.wrap.scrollTop;
      const scrollLeft = this.$refs.originScrollbar.wrap.scrollLeft;
      this.highlightStyleList = this.highlightStyleList.map((item) => {
        return {
          ...item,
          top: item.originTop - scrollTop + item.scrollTop,
          left: item.originLeft - scrollLeft + item.scrollLeft,
        };
      });
    },
    ReRenderPdf() {
      this.isRenderPdf = false;
      clearTimeout(this.renderTimer);
      this.renderTimer = setTimeout(() => {
        this.isRenderPdf = true;
        this.renderHighlight();
      }, 30);
    },
    renderHighlight() {
      if (this.highlightStyleList.length === 0) {
        return;
      }
      const containerRect = this.$refs.pdfContainer.getBoundingClientRect();
      const scale =
        containerRect.width / this.highlightStyleList[0].originContainerWidth;
      const scrollTop = this.$refs.originScrollbar.wrap.scrollTop;
      const scrollLeft = this.$refs.originScrollbar.wrap.scrollLeft;
      this.highlightStyleList = this.highlightStyleList.map((item) => {
        return {
          left: `${(item.left - scrollLeft) * scale}`,
          originLeft: `${item.originLeft * scale}`,
          top: `${(item.top - scrollTop) * scale}`,
          originTop: `${item.originTop * scale}`,
          width: `${item.width * scale}`,
          originContainerWidth: containerRect.width,
          height: `${item.height * scale}`,
          originContainerHeight: containerRect.height,
          scrollTop: item.scrollTop * scale,
          scrollLeft: item.scrollLeft * scale,
        };
      });
      console.log(222, this.highlightStyleList, scale);
    },
    showOrigin() {
      console.log("showOrigin", this.$refs.pdfOriginRef);
      this.renderKey = this.renderKey + 1;
      this.mobilePane = "origin";
      this.showOriginFile = true;
      this.showTranslateFile = false;
      this.ReRenderPdf();
    },
    showAll() {
      this.renderKey = this.renderKey + 1;
      this.mobilePane = "origin";
      this.showOriginFile = true;
      this.showTranslateFile = true;
      this.ReRenderPdf();
    },
    showTranslate() {
      console.log("showTranslate");
      this.mobilePane = "translate";
      this.showOriginFile = false;
      this.showTranslateFile = true;
      this.ReRenderPdf();
    },
    scrollToBottom() {
      this.$refs.answerScrollbarRef.wrap.scrollTop =
        this.$refs.chatListDom.scrollHeight;
    },
    async sendMessage() {
      if (this.isTalking || !this.editorMess) {
        return;
      }
      this.isTalking = true;
      if (this.messageList.length === 0) {
        await this.createChat();
      }
      this.messageList.push({ role: "user", content: this.editorMess });
      const editorMess = this.editorMess;
      this.editorMess = "";
      this.messageList.push({ role: "assistant", content: "" });
      const resData = (
        await this.$http.post("/chatApi/v1/chat/message", {
          model: "SPARK",
          prompt: editorMess,
          chatNumber: this.chatNumber,
          assistantTag: this.currentAssistant.tag,
          assistantTypeTag: "text_query",
          to: this.currentLang,
        })
      ).data;
      if (resData.code === 200) {
        this.conversationId = resData.data;
        const res = await this.chatSend();
        if (res.body) {
          const reader = res.body.getReader();
          await this.readStream(reader, res.status);
        }
      } else if (resData.code === 600 && !resData.success) {
        this.$refs.packagePop.open();
      } else {
        this.$message.error(resData.msg);
      }
    },
    async readStream(reader, status) {
      // let partialLine = "";
      while (true) {
        const { value, done } = await reader.read();
        const decodedText = this.decoder.decode(value, { stream: true });
        if (done) {
          this.isTalking = false;
          break;
        }
        if (status !== 200) {
          this.appendLastMessageContent(decodedText);
          return;
        }
        // const chunk = partialLine + decodedText;
        const newLines = decodedText.split(/\r?\n/);
        // partialLine = newLines.pop() ?? "";
        for (const line of newLines) {
          if (line.length === 0) continue;
          try {
            const json = JSON.parse(line);
            const content =
              status === 200 ? json.content ?? "" : json.error.message;
            this.appendLastMessageContent(content);
          } catch (error) {}
        }
      }
    },
    appendLastMessageContent(content) {
      this.messageList[this.messageList.length - 1].content = content;
    },
    chatSend() {
      return fetch(
        `/chatApi/v1/chat/completions?conversationId=${this.conversationId}`,
        {
          method: "get",
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("token"),
          },
        }
      );
    },
    selectTabChange(type) {
      this.selectTab = type;
      // if (type === "aiTalk" && !this.chatNumber) {
      //   this.createChat();
      // }
    },
    createChat() {
      return this.$http
        .post("/chatApi/v1/chat/createChat", {
          model: "SPARK",
          assistantId: this.currentAssistant.id,
          prompt: this.editorMess,
        })
        .then((res) => {
          this.chatNumber = res.data.data.chatNumber;
        });
    },
    aitTranslate() {
      this.showActions = false;
      const selection = window.getSelection();
      if (!selection.rangeCount || !selection.toString()) {
        this.showActions = false;
        return;
      }
      this.editorMess = selection.toString();
      this.showAINote = true;
      this.selectTab = "aiTalk";
    },
    addNote() {
      console.log("addNote");
      this.isShowNote = true;
      this.showActions = false;
      const selection = window.getSelection();
      if (!selection.rangeCount || !selection.toString()) {
        this.showActions = false;
        return;
      }
      const noteMess = selection.toString();
      this.selectText = noteMess;
    },
    saveNote() {
      if (!this.noteMess) {
        this.$message.info("请输入笔记");
        return;
      }
      this.isShowNote = false;
      this.noteList.push({
        originText: this.selectText,
        note: this.noteMess,
      });
      this.noteMess = "";
      this.showAINote = true;
      this.selectTab = "note";
      console.log(111, this.noteList);
    },
    deleteNote(index) {
      this.noteList.splice(index, 1);
    },
    initPdf() {
      const id = this.$route.params.documentId;
      let request = documentRequest;
      request.setDocId(id);
      const TOKEN_KEY = "token";
      translateServiceClient
        .getDocument(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          console.log(666, res);
          this.originalUrl = res.getOriginalUrl();
          this.translateUrl = res.getTranslateUrl();
          this.title = res.getTitle();
          const to = this.getLanguageName(res.getLanguageTo());
          const from = this.getLanguageName(res.getLanguageFrom());
          this.language = "语言：" + from + "→" + to;
        });
    },
    handleTextSelect() {
      console.log("handleTextSelect");
      if (this.isShowNote) {
        return;
      }
      this.showActions = false;
      this.isShowNote = false;
      const selection = window.getSelection();
      if (!selection.rangeCount || !selection.toString()) {
        this.showActions = false;
        return;
      }
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();
      // 计算相对于PDF容器的位置
      const parentElement = this.$refs.pdfContainer.getClientRects()[0];
      const parentElementScrollLeft = this.$refs.pdfContainer.scrollLeft;
      const parentElementScrollTop = this.$refs.pdfContainer.scrollTop;
      this.showActions = true;
      let left = rect.left - parentElement.left + parentElementScrollLeft - 140;
      left = left < 0 ? 0 : left;
      left = left;
      let top = rect.top - parentElement.top + parentElementScrollTop + 30;
      top = top > parentElement.height - 50 ? parentElement.height - 50 : top;
      this.buttonPosition = {
        left: `${left}px`,
        top: `${top}px`,
      };
    },
    handleSelection() {
      const selection = window.getSelection();
      if (!selection.toString().trim()) return;
      const range = selection.getRangeAt(0);
      if (!this.$refs.pdfContainer.contains(range.commonAncestorContainer)) {
        return;
      }
      // this.clearHighlights();
      // 获取所有文本矩形位置
      const rects = Array.from(range.getClientRects());
      // 过滤无效矩形并合并相邻矩形
      const filteredRects = this.filterAndMergeRects(rects);
      // 为每个文本片段创建高亮
      filteredRects.forEach((rect) => {
        this.createHighlight(rect);
      });
      // 清除文本选中状态
      selection.removeAllRanges();
      this.showActions = false;
    },
    filterAndMergeRects(rects) {
      // 过滤掉宽度或高度为0的无效矩形
      const validRects = rects.filter(
        (rect) => rect.width > 0 && rect.height > 0
      );
      // 合并垂直位置接近的矩形（在同一行）
      const mergedRects = [];
      let currentRect = null;
      validRects.forEach((rect) => {
        if (!currentRect) {
          currentRect = JSON.parse(JSON.stringify(rect));
          return;
        }
        // 检查是否在同一行（y坐标接近）
        const isSameLine = Math.abs(rect.top - currentRect.top) < 5;
        if (isSameLine) {
          // 合并矩形：扩展宽度
          const right = Math.max(currentRect.right, rect.right);
          currentRect.width = right - currentRect.left;
          currentRect.right = right;
        } else {
          // 新的一行
          mergedRects.push(currentRect);
          currentRect = JSON.parse(JSON.stringify(rect));
        }
      });
      if (currentRect) {
        mergedRects.push(currentRect);
      }
      return mergedRects;
    },
    createHighlight(rect) {
      const highlight = document.createElement("div");
      highlight.classList.add("highlight");
      // 计算相对于文本容器的位置
      const containerRect = this.$refs.pdfContainer.getBoundingClientRect();
      const scrollX = window.scrollX;
      const scrollY = window.scrollY;
      highlight.style.left = `${rect.left - containerRect.left + scrollX}px`;
      highlight.style.top = `${rect.top - containerRect.top + scrollY}px`;
      highlight.style.width = `${rect.width}px`;
      highlight.style.height = `${rect.height}px`;
      const scrollTop = this.$refs.originScrollbar.wrap.scrollTop;
      const scrollLeft = this.$refs.originScrollbar.wrap.scrollLeft;
      this.highlightStyleList.push({
        left: `${rect.left - containerRect.left + scrollX}`,
        originLeft: `${rect.left - containerRect.left + scrollX}`,
        top: `${rect.top - containerRect.top + scrollY}`,
        originTop: `${rect.top - containerRect.top + scrollY}`,
        width: `${rect.width}`,
        originContainerWidth: containerRect.width,
        height: `${rect.height}`,
        originContainerHeight: containerRect.height,
        scrollTop: scrollTop,
        scrollLeft: scrollLeft,
      });
      console.log(123, this.highlightStyleList);
      // this.$refs.pdfContainer.appendChild(highlight);
      // this.highlights.push(highlight);
    },
    clearHighlights() {
      this.highlights.forEach((highlight) => {
        if (highlight.parentNode) {
          highlight.parentNode.removeChild(highlight);
        }
      });
      this.highlights = [];
    },
    getHighlightStyle(highlight) {
      return {
        left: `${(highlight.left / 1) * 1}px`,
        top: `${(highlight.top / 1) * 1}px`,
        width: `${(highlight.width / 1) * 1}px`,
        height: `${(highlight.height / 1) * 1}px`,
      };
    },
    screenshot() {
      let screenshot = new RegionScreenshot({
        initialRegion: {
          top: 100,
          left: 200,
          width: 600,
          height: 450,
        },
      });
      screenshot.on("screenshotGenerated", (dataUrl) => {
        console.log(dataUrl);
      });
    },
    // 全屏模式 将方法绑定(点击事件)到页面的元素上即可
    screenfull() {
      if (!screenfull.isEnabled) {
        this.$message({
          center: true,
          message: "您的浏览器无法进入全屏模式",
          type: "warning",
        });
        return false;
      }
      screenfull.toggle();
    },
    downloadFile() {
      this.downloadTitle = "确定下载该文件的译文版本吗？";
      this.downloadClass = "downloadClass";
      this.downloadMessage =
        "下载大型文档或转换文档时，需等待时间较长请您耐心等待！";
      this.downloadPercentage = 0;
      this.isDownload = true;
      this.downloadDocLoad = false;
      this.radio = this.title.substring(this.title.lastIndexOf(".") + 1);
      let id = this.$route.params.documentId;
      if (id.indexOf("-") > 0) {
        this.centerDialogVisible = true;
      } else {
        this.centerDialogVisiblePro = true;
      }
    },
    downloadDoc() {
      this.downloadDocLoad = true;
      let request = readingFileRequest;
      request.setId(this.$route.params.documentId);
      request.setType(this.radio);
      const TOKEN_KEY = "token";
      let stream = translateServiceClient.downLoadFile(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      });
      this.isDownload = false;
      this.downloadDocLoad = true;
      this.downloadClass = "downloadClass2";
      this.downloadTitle = "";
      let flag = 0;
      let content = "";
      let title = "";
      let type = "";
      let count = 0;
      this.downloadTimer = setInterval(() => {
        if (this.downloadPercentage < 98) {
          this.downloadPercentage += 1;
        }
        if (this.downloadPercentage === 100) {
          count += 1;
          if (count === 3) {
            clearInterval(this.downloadTimer);
            this.isDownload = true;
            this.downloadDocLoad = false;
            this.centerDialogVisible = false;
            this.centerDialogVisiblePro = false;
            this.customColorDownload = "var(--primary-dark)";
          }
        }
        if (this.downloadPercentage === 99) {
          this.customColorDownload = "#38cb1c";
          this.downloadMessage = "下载完成";
          this.downloadPercentage = 100;
        }
      }, 1000);
      stream.on("data", (res) => {
        if (res.getStatus() && flag === 0) {
          title = res.getTitle();
          type = res.getType();
        }
        if (!res.getStatus() && flag === 0) {
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "下载文件失败",
          });
          clearInterval(this.downloadTimer);
          this.isDownload = true;
          this.downloadDocLoad = false;
          this.centerDialogVisible = false;
          this.centerDialogVisiblePro = false;
          return;
        }
        flag++;
        content += res.getContent_asB64();
      });
      stream.on("end", (end) => {
        let aLink = document.createElement("a");
        let blob = this.base64ToBlob(content, type);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true);
        aLink.download = title;
        aLink.href = URL.createObjectURL(blob);
        aLink.click();
        this.downloadPercentage = 99;
      });
      stream.on("error", (err) => {
        clearInterval(this.downloadTimer);
        this.isDownload = true;
        this.downloadDocLoad = false;
        this.centerDialogVisible = false;
        this.centerDialogVisiblePro = false;
        if (err && err.code === 5) {
          this.$router.push("/index");
          window.parent.postMessage(
            {
              data: "params",
            },
            "*"
          );
          return;
        }
        if (err && err.code !== 0) {
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "下载文档失败，请稍后再试！",
          });
        }
      });
    },
    base64ToBlob(code, type) {
      let bstr = atob(code);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: type });
    },
  },
};
</script>
<style>
.el-select-dropdown__item.selected {
  color: var(--primary);
}
</style>
<style lang="less" scoped>
.downloadClass {
  height: 430px;
  border-radius: 6px;
}
.downloadClass2 {
  height: 317px;
  border-radius: 6px;
}
.down-type {
  float: left;
  margin: 0 25px;
}
/deep/ .el-radio {
  margin: 0;
  position: absolute;
}
/deep/ .el-radio__label {
  display: none;
}
.pdf-view {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  .pdf-view-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    .pdf-tools {
      display: flex;
      line-height: 70px;
      border-bottom: 1px solid #f1f2f3;
      align-items: center;
      justify-content: space-between;
      .title {
        font-size: 18px;
        color: #000000;
        margin-left: 50px;
      }
      .lange {
        font-size: 18px;
        color: #666666;
      }
      .download {
        cursor: pointer;
        margin-right: 40px;
        color: #666666;
        font-size: 24px;
      }
    }
    .pdf-container {
      display: flex;
      height: calc(100% - 72px);
      background: #eceeef;
      flex: 1;
      .pdf-origin {
        height: 100%;
        // width: calc(50% - 130px);
        flex: 1;
        position: relative;
        overflow-y: auto;
        overflow-x: hidden;
        margin: 0 auto;
        /* 精确高亮样式 */
        /deep/.highlight {
          position: absolute;
          background: rgba(0, 86, 227, 0.15);
          border-radius: 3px;
          pointer-events: none;
          z-index: 10;
        }
        .origin-scrollbar {
          height: 100%;
          /deep/.el-scrollbar__wrap {
            overflow-x: hidden;
          }
          /deep/.el-scrollbar__bar.is-horizontal {
            overflow: hidden;
          }
        }
      }
      .action {
        width: 26px;
        height: 100%;
        position: relative;
        color: #a9a9a9;
        .show-origin {
          position: absolute;
          left: 0;
          top: 30%;
          cursor: pointer;
          font-size: 26px;
        }
        .show-all {
          position: absolute;
          left: 0;
          top: 40%;
          cursor: pointer;
          font-size: 16px;
          background: #a9a9a9;
          border-radius: 100%;
          color: #fff;
          width: 26px;
          height: 26px;
          line-height: 26px;
          text-align: center;
        }
        .show-translate {
          position: absolute;
          left: 0;
          top: 48%;
          transform: rotate(180deg);
          cursor: pointer;
          font-size: 26px;
        }
      }
      .pdf-translate {
        height: 100%;
        // width: calc(50% - 130px);
        flex: 1;
        overflow-y: auto;
        // background: #f3f5f8;
        // border: 1px solid #eceeef;
        position: relative;
        margin: 0 auto;
        .download-file {
          position: absolute;
          right: 30px;
          top: 30px;
          z-index: 3;
          cursor: pointer;
          font-size: 14px;
          padding: 4px 6px;
          border-radius: 6px;
          color: #333;
          background: #f0f2f5;
          border: 1px solid #eceeef;
          &:hover {
            color: var(--primary);
          }
        }
        .translate-scrollbar {
          height: 100%;
          /deep/.el-scrollbar__wrap {
            overflow-x: hidden;
          }
          /deep/.el-scrollbar__bar.is-horizontal {
            overflow: hidden;
          }
        }
      }
      .highlight-layer {
        position: absolute;
        pointer-events: none;
        mix-blend-mode: multiply;
      }
      .note-pop {
        position: absolute;
        z-index: 100;
        width: 340px;
        padding-bottom: 46px;
        background: #ffffff;
        box-shadow: 0px 0px 5px 0px rgba(71, 71, 71, 0.4);
        border-radius: 6px;
        border: 1px solid #d4d4d4;
        .title {
          width: 100%;
          height: 40px;
          line-height: 40px;
          background: #f3f5f8;
          position: relative;
          padding: 0 12px;
          box-sizing: border-box;
          .close {
            position: absolute;
            cursor: pointer;
            right: 10px;
            top: 10px;
          }
        }
        .note-message {
          box-sizing: border-box;
          border-radius: 6px;
          margin: 10px 12px;
          width: 316px;
        }
        .save-note {
          cursor: pointer;
          background: var(--primary);
          border-radius: 6px;
          width: 70px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          font-size: 14px;
          color: #ffffff;
          position: absolute;
          right: 10px;
          bottom: 15px;
          border: none;
        }
      }
      .action-buttons {
        position: absolute;
        z-index: 100;
        width: 180px;
        height: 40px;
        background: #ffffff;
        box-shadow: 0px 0px 5px 0px rgba(71, 71, 71, 0.4);
        border-radius: 6px;
        border: 1px solid #d4d4d4;
        display: flex;
        text-align: center;
        align-items: center;
        padding: 0 6px;
        .item {
          flex: 1;
          cursor: pointer;
          padding: 6px 0;
          background: none;
          border: none;
          &:hover {
            background: #f0f2f5;
            border-radius: 6px;
            color: var(--primary);
          }
        }
      }
    }
  }
  .pdf-ai-container {
    display: flex;
    .blank {
      background: #ffffff;
      border-left: 1px solid #eceeef;
      width: 12px;
      height: 100%;
      box-sizing: border-box;
      &.full {
        width: 70px;
      }
    }
    .pdf-ai {
      width: 280px;
      height: 100%;
      background: #ffffff;
      box-shadow: 0px 5px 7px 0px rgba(123, 136, 146, 0.17);
      border: 1px solid #eceeef;
      z-index: 1;
      position: relative;
      box-sizing: border-box;
      .pack-up {
        position: absolute;
        left: -22px;
        top: 45%;
        font-size: 32px;
        color: #1296db;
        cursor: pointer;
      }
      .tabs {
        height: 68px;
        background: #f3f5f8;
        display: flex;
        align-items: center;
        .tab {
          width: 50%;
          text-align: center;
          font-size: 18px;
          cursor: pointer;
          &.select {
            span {
              display: inline-block;
              height: 38px;
              line-height: 38px;
              width: 100px;
              background: var(--primary);
              border-radius: 4px;
              color: #ffffff;
            }
          }
        }
      }
      .note-scrollbar {
        height: 100%;
        /deep/.el-scrollbar__wrap {
          overflow-x: hidden;
        }
        /deep/.el-scrollbar__bar.is-horizontal {
          overflow: hidden;
        }
      }
      .ai-scrollbar {
        height: calc(100% - 210px);
        /deep/.el-scrollbar__wrap {
          overflow-x: hidden;
        }
        /deep/.el-scrollbar__bar.is-horizontal {
          overflow: hidden;
        }
        .ai-list {
          font-size: 14px;
          padding: 0 14px;
        }
      }
      .answer-container {
        padding: 20px 0;

        .right {
          text-align: right;
        }
        .left {
          text-align: left;
        }

        .answer-item {
          display: inline-block;
          position: relative;
          margin-bottom: 16px;
        }
        .answer-item.assistant {
          border-radius: 10px;
          background-color: #f5f5f5;
          padding-left: 20px;
          padding-right: 20px;
        }
        .answer-item.assistant:hover {
          background-color: rgb(241 245 249);
        }
        .answer-item .user-answer {
          border-radius: 10px;
          background-color: #f1e6d1;
          padding: 12px 20px;
          text-align: left;
        }

        .user {
          padding-top: 0;
          .action {
            right: 0;
          }
        }
      }
      .note-list {
        padding: 0 5px;
        .note-item {
          position: relative;
          border-radius: 6px;
          border: 1px solid #e5e7f3;
          margin-top: 10px;
          font-size: 14px;
          color: #666666;
          line-height: 20px;
          padding: 20px 12px;
          box-sizing: border-box;
          .delete-note {
            position: absolute;
            right: -8px;
            top: -8px;
            font-size: 18px;
            cursor: pointer;
          }
          .note {
            margin-top: 14px;
            background: #c9daf6;
            border-radius: 4px;
            font-size: 14px;
            color: #444444;
            line-height: 28px;
            padding: 10px;
          }
        }
        .empty {
          width: 80px;
          margin: 100px auto;
        }
      }
      .chat-editor {
        height: 130px;
        background: #fff;
        border-radius: 10px;
        border: 1px solid #eceeef;
        margin: 28px 10px 0;
        position: relative;
        font-size: 14px;
        box-sizing: border-box;
        .select-lang {
          position: absolute;
          top: -40px;
          right: 0;
          height: 30px;
          width: 95px;
          line-height: 30px;
          background: #f3f5f8;
          border-radius: 6px;
          /deep/.el-input {
            background: #f3f5f8;
            border-radius: 6px;
          }
          /deep/.el-input__inner {
            background: #f3f5f8;
            border: none;
            border-radius: 6px;
            color: #060606;
          }
        }

        .editor-message {
          padding-top: 10px;
          border-radius: 10px;
          height: calc(100% - 40px);

          /deep/.el-textarea__inner {
            border: none;
            border-radius: 10px;
            font-size: 18px;
            height: 100%;
          }
          /deep/.el-input__inner::placeholder {
            font-size: 18px;
          }
        }

        .send-message {
          width: 18px;
          height: 18px;
          background: #b2b5b9;
          border-radius: 50%;
          position: absolute;
          right: 10px;
          bottom: 9px;
          cursor: pointer;
          &.active {
            background: var(--primary);
          }
          .send {
            width: 10px;
            height: 8px;
            display: inline-block;
            background: url(../../../assets/chat/send.png) center no-repeat;
            background-size: contain;
            margin: 6px 0 0 4px;
            vertical-align: super;
          }
        }
      }
    }
    /deep/.el-tabs__item {
      &.is-active {
        color: var(--primary);
      }
    }
    /deep/.el-tabs__item:not(.is-disabled):hover {
      color: var(--primary);
    }
    /deep/ .el-tabs--border-card {
      height: 100%;
      .el-tabs__content {
        height: calc(100% - 40px);
        padding: 0;
        .el-tab-pane {
          height: 100%;
        }
      }
    }
  }
}

/* 首页主题下的 PDF 工作区 */
.pdf-view {
  --pdf-brand-strong: var(--primary-dark);
  --pdf-brand: var(--primary);
  --pdf-brand-light: #3f9bd2;
  --pdf-brand-soft: #f0f6ff;
  --pdf-canvas: #eef4f8;
  --pdf-surface: #ffffff;
  --pdf-text: #1a1a2e;
  --pdf-text-secondary: #6b7280;
  --pdf-border: #dce4e7;

  min-width: 0;
  min-height: 0;
  position: relative;
  color: var(--pdf-text);
  border: 1px solid var(--pdf-border);
  border-radius: 15px;
  background: var(--pdf-surface);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);

  .pdf-view-container {
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    border-radius: 15px;
    background: var(--pdf-surface);

    .pdf-tools {
      min-height: 76px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      line-height: normal;
      border-bottom: 1px solid var(--pdf-border);
      background: rgba(255, 255, 255, 0.98);
      box-sizing: border-box;

      .pdf-tools-main {
        width: 100%;
        min-width: 0;
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto auto;
        align-items: center;
        gap: 18px;
      }

      .document-heading {
        min-width: 0;
      }

      .document-kicker {
        display: block;
        margin-bottom: 3px;
        color: var(--pdf-brand);
        font-size: 10px;
        font-weight: 700;
        line-height: 15px;
        letter-spacing: 1.5px;
      }

      .title {
        min-width: 0;
        margin-left: 0;
        overflow: hidden;
        color: var(--pdf-text);
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .lange {
        max-width: 300px;
        padding: 8px 12px;
        display: inline-flex;
        align-items: center;
        gap: 7px;
        overflow: hidden;
        color: var(--pdf-text-secondary);
        font-size: 13px;
        line-height: 20px;
        border: 1px solid #e0e9f2;
        border-radius: 9px;
        background: #f8fbfe;

        i {
          flex: 0 0 auto;
          color: var(--pdf-brand);
          font-size: 15px;
        }

        span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .download {
        min-width: 112px;
        height: 40px;
        margin-right: 0;
        padding: 0 16px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 7px;
        color: #ffffff;
        font-size: 14px;
        font-weight: 600;
        border: 0;
        border-radius: 9px;
        background: var(--pdf-brand-strong);
        box-shadow: 0 5px 14px rgba(0, 0, 0, 0.22);
        cursor: pointer;
        transition: transform 0.16s ease, box-shadow 0.16s ease,
          background 0.16s ease;

        &:hover {
          background: var(--pdf-brand);
          box-shadow: 0 7px 18px rgba(0, 0, 0, 0.24);
          transform: translateY(-1px);
        }

        &:focus-visible {
          outline: 2px solid var(--pdf-brand-light);
          outline-offset: 2px;
        }
      }

      .mobile-pane-switch {
        display: none;
      }
    }

    .pdf-container {
      min-width: 0;
      min-height: 0;
      height: auto;
      padding: 12px;
      gap: 12px;
      background: var(--pdf-canvas);
      box-sizing: border-box;

      .pdf-origin,
      .pdf-translate {
        min-width: 0;
        height: 100%;
        overflow: hidden;
        border: 1px solid var(--pdf-border);
        border-radius: 12px;
        background: #e5eaee;
        box-shadow: 0 4px 14px rgba(18, 40, 64, 0.06);
      }

      .pane-label {
        position: absolute;
        z-index: 8;
        top: 10px;
        left: 10px;
        height: 28px;
        padding: 0 10px;
        display: inline-flex;
        align-items: center;
        gap: 5px;
        color: #ffffff;
        font-size: 12px;
        font-weight: 700;
        line-height: 28px;
        border: 0;
        border-radius: 8px;
        background: var(--primary);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
        pointer-events: none;
        backdrop-filter: blur(6px);
      }

      .origin-scrollbar,
      .translate-scrollbar {
        height: 100%;
      }

      /deep/ .vue-pdf-embed__page {
        margin: 0 auto 12px;
        background: #ffffff;
        box-shadow: 0 2px 10px rgba(18, 40, 64, 0.08);
      }

      /deep/ .vue-pdf-embed__page canvas {
        display: block;
        max-width: 100%;
        height: auto;
      }

      .action {
        width: 44px;
        flex: 0 0 44px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 10px;
        color: var(--pdf-brand);

        .show-origin,
        .show-all,
        .show-translate {
          position: static;
          width: 36px;
          height: 36px;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--pdf-brand);
          font-size: 18px;
          line-height: 36px;
          border: 1px solid #d6e5ef;
          border-radius: 10px;
          background: #ffffff;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          cursor: pointer;
          transition: color 0.16s ease, background 0.16s ease,
            box-shadow 0.16s ease;

          &:hover,
          &:focus-visible {
            color: #ffffff;
            background: var(--pdf-brand-strong);
            box-shadow: 0 5px 14px rgba(0, 0, 0, 0.2);
            outline: none;
          }
        }

        .show-all {
          color: #ffffff;
          background: var(--pdf-brand);
        }

        .show-translate {
          transform: rotate(180deg);
        }
      }

      .note-pop,
      .action-buttons {
        border-color: #dce4e7;
        border-radius: 10px;
        box-shadow: 0 10px 28px rgba(18, 40, 64, 0.16);
      }
    }
  }

  .pdf-ai-container {
    min-width: 0;

    .blank {
      width: 10px;
      border-left-color: var(--pdf-border);

      &.full {
        width: 52px;
      }
    }

    .pdf-ai {
      border-color: var(--pdf-border);
      background: var(--pdf-surface);
      box-shadow: -6px 0 20px rgba(0, 0, 0, 0.08);

      .pack-up {
        width: 32px;
        height: 32px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--pdf-brand);
        font-size: 17px;
        border: 1px solid #d6e5ef;
        border-radius: 50%;
        background: #ffffff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
      }
    }
  }
}

.downloadClass,
.downloadClass2 {
  position: relative;
}

.download-section-title {
  color: #1a1a2e !important;
  font-weight: 600 !important;
}

.download-options {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.down-type {
  cursor: pointer;
}

.el-button--primarys {
  color: #ffffff !important;
  border-color: var(--primary-dark) !important;
  border-radius: 9px !important;
  background: var(--primary-dark) !important;
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.2);
}

.el-button--defaults {
  color: var(--primary-dark) !important;
  border-color: #b9cfe0 !important;
  border-radius: 9px !important;
  background: #ffffff !important;
}

/deep/ .el-dialog {
  max-width: calc(100vw - 24px);
  overflow: hidden;
  border-radius: 15px;
  box-shadow: 0 20px 55px rgba(18, 40, 64, 0.2);
}

/deep/ .el-dialog__header {
  padding: 22px 24px 14px;
}

/deep/ .el-dialog__title {
  color: #1a1a2e;
  font-weight: 700;
}

@media (min-width: 769px) and (max-width: 1100px) {
  .pdf-view {
    .pdf-view-container {
      .pdf-tools {
        padding: 0 14px;

        .pdf-tools-main {
          gap: 10px;
        }

        .lange {
          max-width: 210px;
        }

        .download {
          min-width: 94px;
          padding: 0 12px;
        }
      }

      .pdf-container {
        padding: 8px;
        gap: 8px;

        .action {
          width: 38px;
          flex-basis: 38px;

          .show-origin,
          .show-all,
          .show-translate {
            width: 32px;
            height: 32px;
          }
        }
      }
    }

    .pdf-ai-container .blank.full {
      width: 44px;
    }
  }
}

@media (max-width: 768px) {
  .pdf-view {
    width: 100%;
    min-height: 0;
    border-radius: 12px;
    box-shadow: 0 5px 16px rgba(0, 0, 0, 0.08);

    .pdf-view-container {
      width: 100%;
      border-radius: 12px;

      .pdf-tools {
        min-height: 128px;
        padding: 10px 12px;
        align-items: stretch;
        flex-direction: column;

        .pdf-tools-main {
          display: grid;
          grid-template-columns: minmax(0, 1fr) 44px;
          gap: 7px 10px;
        }

        .document-kicker {
          margin-bottom: 1px;
          font-size: 9px;
          line-height: 13px;
        }

        .title {
          font-size: 14px;
          line-height: 21px;
        }

        .lange {
          grid-column: 1 / 3;
          max-width: 100%;
          padding: 4px 8px;
          justify-self: start;
          font-size: 11px;
          line-height: 18px;
          border-radius: 7px;
        }

        .download {
          width: 44px;
          min-width: 44px;
          height: 44px;
          padding: 0;
          grid-column: 2;
          grid-row: 1;
          border-radius: 10px;

          span {
            display: none;
          }

          i {
            font-size: 18px;
          }
        }

        .mobile-pane-switch {
          width: 100%;
          height: 36px;
          margin-top: 8px;
          padding: 3px;
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 3px;
          border: 1px solid #e0e9f2;
          border-radius: 9px;
          background: #f0f6ff;
          box-sizing: border-box;

          button {
            min-width: 0;
            padding: 0 12px;
            color: #697586;
            font-size: 12px;
            font-weight: 600;
            border: 0;
            border-radius: 7px;
            background: transparent;
            cursor: pointer;

            &.active {
              color: #ffffff;
              background: var(--pdf-brand-strong);
              box-shadow: 0 3px 9px rgba(0, 0, 0, 0.18);
            }
          }
        }
      }

      .pdf-container {
        width: 100%;
        min-height: 0;
        padding: 6px;
        display: flex;
        gap: 0;

        .pdf-origin,
        .pdf-translate {
          width: 100%;
          min-width: 0;
          flex: 1 1 100%;
          border-radius: 9px;
        }

        .action {
          display: none;
        }

        .pane-label {
          top: 8px;
          left: 8px;
          height: 26px;
          padding: 0 8px;
          font-size: 11px;
          line-height: 26px;
          border-radius: 7px;
        }

        .note-pop {
          width: calc(100% - 16px);
          max-width: 340px;

          .note-message {
            width: calc(100% - 24px);
          }
        }

        .action-buttons {
          max-width: calc(100% - 16px);
        }
      }
    }

    .pdf-ai-container {
      position: absolute;
      z-index: 30;
      inset: 0;
      display: block;
      pointer-events: none;

      .blank {
        display: none;
      }

      .pdf-ai {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        border: 0;
        border-radius: 12px;
        pointer-events: auto;
        box-shadow: 0 12px 32px rgba(18, 40, 64, 0.22);

        .pack-up {
          z-index: 4;
          top: 8px;
          right: 10px;
          left: auto;
          width: 34px;
          height: 34px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--pdf-brand-strong);
          font-size: 22px;
          border: 1px solid #d6e5ef;
          border-radius: 50%;
          background: #eef5fb;
          transform: none;
        }
      }
    }
  }

  /deep/ .el-dialog {
    width: calc(100vw - 24px) !important;
    margin-top: 6vh !important;
  }

  /deep/ .el-dialog__header {
    padding: 18px 42px 10px 16px;
    text-align: left;
  }

  /deep/ .el-dialog__title {
    font-size: 16px;
    line-height: 22px;
  }

  /deep/ .el-dialog__body {
    padding: 10px 14px 18px;
  }

  .downloadClass,
  .downloadClass2 {
    height: auto !important;
    min-height: 340px;
  }

  .download-section-title {
    width: auto !important;
    margin: 0 0 12px !important;
    font-size: 15px !important;
  }

  .download-section-title--secondary {
    margin-top: 22px !important;
  }

  .download-options {
    margin: 0 !important;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;
  }

  .download-options--bilingual {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .down-type {
    min-width: 0;
    margin: 0;
    float: none;
    text-align: center;

    img {
      width: 42px !important;
      height: 54px !important;
      max-width: 100%;
    }

    > div {
      margin-top: 8px !important;
      overflow: hidden;
      font-size: 11px;
      line-height: 16px !important;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .download-dialog-actions {
    position: static !important;
    margin-top: 28px;
    display: flex;
    justify-content: center;
    transform: none !important;
  }

  .download-progress-state {
    img {
      width: 100% !important;
      max-width: 300px;
      height: auto !important;
    }

    > div:nth-child(2) {
      width: 100% !important;
      height: auto !important;
      margin: 12px 0 24px !important;
      font-size: 14px !important;
      line-height: 22px !important;
      transform: none !important;
    }

    > div:last-child {
      width: 100%;
      position: static !important;
      transform: none !important;
    }

    /deep/ .el-progress {
      width: 100% !important;
    }
  }
}
</style>
